import { BRAND } from "@/lib/brand";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-20 lg:pt-28 pb-10 overflow-hidden"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4">
              <img
                src={BRAND.logoUrl}
                alt="MHJ Prestige Transport"
                className="h-16 w-16 object-contain"
              />
              <div>
                <div className="font-display font-extrabold text-white text-2xl tracking-tight">
                  MHJ PRESTIGE
                </div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-400 mt-1">
                  Transport · Recovery
                </div>
              </div>
            </div>
            <p className="mt-8 max-w-md text-zinc-400 text-sm lg:text-base leading-relaxed">
              Owner-operated vehicle recovery and transport, based in Burton
              Upon Trent, covering the UK and Europe. Prestige cars, classics
              and everyday motors — moved with the same care.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Sitemap
            </div>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li><a href="/#services" className="hover:text-white" data-testid="footer-link-services">Services</a></li>
              <li><a href="/#why" className="hover:text-white" data-testid="footer-link-why">Why MHJ</a></li>
              <li><a href="/#coverage" className="hover:text-white" data-testid="footer-link-coverage">Coverage</a></li>
              <li><a href="/blog" className="hover:text-white" data-testid="footer-link-blog">Blog</a></li>
              <li><a href="/#quote" className="hover:text-white" data-testid="footer-link-quote">Get a quote</a></li>
              <li><a href="/#contact" className="hover:text-white" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-5">
              Direct
            </div>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-white" data-testid="footer-phone">
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="hover:text-white break-words" data-testid="footer-email">
                  {BRAND.email}
                </a>
              </li>
              <li className="text-zinc-400">{BRAND.location}</li>
              <li className="text-zinc-400">24 / 7 callout</li>
            </ul>
          </div>
        </div>

        {/* Huge brand wordmark */}
        <div className="mt-16 lg:mt-24 border-t border-white/10 pt-10 overflow-hidden">
          <div className="font-display font-extrabold text-white/[0.04] text-[18vw] leading-none tracking-tighter select-none whitespace-nowrap">
            MHJ PRESTIGE
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-zinc-500">
          <div>© {year} MHJ Prestige Transport Ltd. All rights reserved.</div>
          <div className="flex items-center gap-6 flex-wrap">
            <a href="/track" data-testid="footer-track" className="hover:text-white tracking-[0.2em] uppercase">Track booking</a>
            <a href="/terms" data-testid="footer-terms" className="hover:text-white tracking-[0.2em] uppercase">Terms</a>
            <a href="/privacy" data-testid="footer-privacy" className="hover:text-white tracking-[0.2em] uppercase">Privacy</a>
            <a
              href={BRAND.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="hover:text-white tracking-[0.2em] uppercase"
            >
              Instagram
            </a>
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="hover:text-white tracking-[0.2em] uppercase"
            >
              Admin
            </a>
            <span className="tracking-[0.2em] uppercase">Burton Upon Trent · UK & Europe</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
